// Shared class + config constants for the React sidebar. Values mirror the
// Phlex sidebar (sidebar_component.rb) and the design tokens so the migrated
// component is a visual 1:1.

// Persisted collapse state — same key the old Stimulus controller used, so a
// user's preference survives the migration.
export const COLLAPSE_STORAGE_KEY = 'sidebar-collapsed';

// Widths must match the CSS transition target (transition-[width]).
export const SIDEBAR_WIDTH_EXPANDED = 'w-60';
export const SIDEBAR_WIDTH_COLLAPSED = 'w-24';

// The `--sidebar-width` CSS variable (on :root) is consumed by fixed preview
// footers (`left: var(--sidebar-width)`). The sidebar keeps it in sync on
// collapse, preserving the contract the old Stimulus controller maintained.
export const SIDEBAR_WIDTH_VAR = '--sidebar-width';
export const SIDEBAR_WIDTH_VAR_EXPANDED = '210px';
export const SIDEBAR_WIDTH_VAR_COLLAPSED = '72px';

// 15px nav icons (w-5 on the 3px spacing scale). The primitives are exported
// with tight-cropped viewBoxes (glyph fills the box), so 15px keeps their
// apparent line weight ~1.5px and consistent across the set — at 18px the
// filled family renders noticeably heavier than the stroke-based icons.
export const NAV_ICON_CLASS = 'w-5 h-5 text-icon-primary flex-shrink-0';

export const DISABLED_ITEM_CLASS = 'opacity-40 cursor-not-allowed pointer-events-none';

// Expandable toggle button — same row metrics/type/fade as `.nav-link`, minus
// the gap (it lays out label vs chevron with justify-between).
export const EXPANDABLE_BUTTON_BASE =
  'flex items-center justify-between w-full px-4 py-3 rounded-input font-semibold text-sm sidebar-row-fade';

// Sub-item / status-filter row. Follows the Figma nested-menu spec (compact
// 29px rows, 5px radius) tuned to the sidebar's 14px ramp: h-9 (27px) rows.
export const SUB_ITEM_BASE =
  'font-semibold flex items-center justify-between h-9 px-4 rounded-xs text-sm text-text-primary sidebar-row-fade';

// Sub-item row inside a collapsed-mode floating popover.
export const POPOVER_ROW_BASE =
  'flex items-center justify-between px-[18px] py-3 text-sm text-text-primary bg-off-white rounded-lg font-semibold sidebar-row-fade';

// Applied by FloatingPopover to every sidebar popover's portal root. Popovers
// portal into document.body, escaping both the sidebar's font-inter scope and its
// stacking context, so the shell has to restate them.
//
// z-[60] is the repo's menu tier: above page chrome (fixed footers at z-10, table
// headers at z-20) and above the dialog/sheet overlays at z-50, but below tooltips
// at z-[70]. See app/frontend/components/ui/popover.tsx, which documents the same
// tier for the same reason.
export const POPOVER_SHELL_CLASS = 'font-inter z-[60]';

// Surface styling for the collapsed nav-item / expandable popovers. Stacking and
// font come from POPOVER_SHELL_CLASS — do not restate them here.
export const POPOVER_CLASS =
  'floating-dropdown-menu bg-off-white border-[0.5px] border-disable rounded-lg shadow-lg overflow-hidden w-52 p-[3px]';
